// --- Environment variable getters (single source of truth) ---

export const getEnvironment = (): string => import.meta.env.VITE_ENVIRONMENT;

export const getVersion = (): string => import.meta.env.VITE_VERSION;

export const getEternoDomain = (): string => import.meta.env.VITE_ETERNO_DOMAIN;

export const getSentryDsn = (): string => import.meta.env.VITE_SENTRY_DSN;

export const getCognitoUserPoolId = (): string => import.meta.env.VITE_COGNITO_USER_POOL_ID;

export const getCognitoClientId = (): string => import.meta.env.VITE_COGNITO_CLIENT_ID;

export const getCognitoDomain = (): string => import.meta.env.VITE_COGNITO_DOMAIN;

export const getPrismicRepo = (): string => import.meta.env.VITE_PRISMIC_REPO;

export const getPrismicAccessToken = (): string => import.meta.env.VITE_PRISMIC_ACCESS_TOKEN;

export const getConfigCatSdkKey = (): string | undefined => import.meta.env.VITE_CONFIG_CAT_SDK_KEY;

// --- Derived environment checks ---

export const isLocalEnvironment = (): boolean => {
    return globalThis.location.hostname === 'localhost' || globalThis.location.hostname === '127.0.0.1';
};

export const isDevEnvironment = (): boolean => {
    return getEnvironment() === 'dev';
};

export const isProdEnvironment = (): boolean => {
    return getEnvironment() === 'prod';
};

export const isEternoDomain = (): boolean => globalThis.location.hostname.includes(getEternoDomain());

export const isCorrectWhiteLabelDomain = (domain: string): boolean => globalThis.location.hostname.includes(domain);

export const isSalesEnvironment = (customerKey: string): boolean => {
    return isDevEnvironment() && customerKey === 'praxis-wolke';
};
